<template>
  <div>
    <b-card v-loading="tableLoading" class="attendance-data">
      <div class="attendance-header">
        <div class="title">
          <p>{{ selectAttendance }}</p>
        </div>
        <div class="attendance-select">
          <b-form-select
            style="width: 285px; margin-bottom: 10px"
            @change="changeAttendance"
            v-model="selectAttendance"
            :options="optionAttendance"
          ></b-form-select>
        </div>
      </div>
      <div class="date-pick">
        <div class="from-date">
          <label for="example-datepicker">From</label>
          <datePickerCom
            class="mb-2"
            :isDisabled="!hideBox"
            :pickTimeVal.sync="fromDate"
            :inputWidth="'200px'"
          />
        </div>
        <div class="to-date">
          <label for="example-datepicker">to</label>
          <datePickerCom
            class="mb-2"
            :pickerOptions="{ disabledDate }"
            :isDisabled="!hideBox"
            :pickTimeVal.sync="toDate"
            :inputWidth="'200px'"
          />
        </div>
        <div class="hide-checkbox">
          <b-form-checkbox
            id="hide-checkbox-1"
            v-model="hideBox"
            name="checkbox-1"
            :value="true"
            :unchecked-value="false"
          >
          </b-form-checkbox>
        </div>
      </div>
      <div class="search">
        <!-- 地區 -->
        <el-select
          v-model="areaSelect"
          :loading="areaLoading"
          loading-text="數據加載中..."
          popper-append-to-body
          popper-class="option-group"
          v-if="selectAttendance !== '入座率資料(By house)'"
          class="mr-1 search-select"
          style="width: 25%"
          placeholder="Select districts"
        >
          <el-option
            v-for="(item, index) in areaList"
            :key="index"
            :label="item.name"
            :value="item.id"
            @click.native="selectAreaChange(item.id)"
          >
          </el-option>
        </el-select>
        <!-- 戲院 -->
        <el-select
          v-if="selectAttendance !== '入座率資料(By theatre)' && selectAttendance !== '入座率資料(By circuit)'"
          v-model="selectCircuit"
          loading-text="數據加載中..."
          :loading="theatreLoading"
          popper-append-to-body
          popper-class="option-group"
          class="mr-1 search-select"
          style="width: 25%"
          :placeholder="selectForFilm"
        >
          <el-option
            v-for="(item, index) in newFilmList"
            :disabled="item.is_closed"
            :key="index"
            @click.native="selectCircuitOption(item)"
            :label="item.full_name"
            :value="
              item.circuit_key
                ? `${item.full_name}:${item.circuit_key}`
                : `${item.full_name}:${item.circuit_id}`
            "
          >
          </el-option>
        </el-select>
        <!-- 上映中或即將上映的電影(By theatre) -->
        <el-select
          v-if="selectAttendance === '入座率資料(By theatre)' || selectAttendance === '入座率資料(By circuit)' "
          v-model="selectPengdingFilm"
          clearable
          loading-text="數據加載中..."
          :loading="theatreLoading"
          popper-append-to-body
          popper-class="option-group-pending"
          @change="selectPengdingChange"
          class="mr-1 search-select"
          style="width: 45%"
          :placeholder="selectForFilm"
        >
          <el-option
            v-for="(item, index) in pengdingFilmList"
            :key="index"
            @click.native="selectPengdingOption(item)"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
        <!-- 所有電影(By theatre && By film) -->
        <!-- <el-autocomplete
          :key="inputSelectKey"
          v-if="selectAttendance !== '入座率資料(By house)'"
          class="inline-input mr-1 all-film-list"
          v-model="inputForFilm"
          @change="inputSearchFilmChange"
          @input="inputSearchFilm"
          :fetch-suggestions="querySearch"
          placeholder="搜尋所有電影"
          style="width: 100%"
          @select="searchFilmInput"
          clearable
        ></el-autocomplete> -->
        <el-select
          v-if="selectAttendance !== '入座率資料(By house)'"
          v-model="inputForFilm"
          filterable
          clearable
          class="inline-input mr-1 all-film-list"
          style="width: 100%"
          placeholder="搜尋所有電影"
          :remote="true"
          :remote-method="remoteMethod"
          :loading="searchFilmLoading"
          @clear="clearSearchFilm"
        >
          <el-option
            v-for="option in filmList"
            :key="'film' + option.id + option.run_ver"
            popper-append-to-body
            :label="option.value"
            :value="option.id"
          >
            <div @click="searchFilmInput(option)">{{ option.value }}</div>
          </el-option>
        </el-select>
        <b-button
          :disabled="canSearch"
          variant="primary"
          @click="searchInfo(selectAttendance)"
        >
          Search
        </b-button>
      </div>
      <p v-show="showTabel">
        <b>{{ displayText }}
        </b>
      </p>
      <b-table
        bordered
        v-show="showTabel"
        striped
        hover
        responsive
        :items="attendanceData"
        :fields="
          $store.state.highlightCol.firTable
            ? $store.state.newTableFields
            : tableFields
        "
        @head-clicked="
          commonHighLightCol(
            $event,
            tableFields,
            $store.state.newTableFields,
            'firTable'
          )
        "
      >
        <template #thead-top="data">
          <b-tr>
            <b-th
                :colspan="selectAttendance === '入座率資料(By film)'
                ? 8 : selectAttendance === '入座率資料(By theatre)'
                ? 3 : selectAttendance === '入座率資料(By circuit)'
                ? 2 : 4"
            ></b-th>
            <b-th v-if="selectAttendance === '入座率資料(By circuit)'" > TOTAL THEATRE :{{ parseFloat(totalData.num_of_theatre).toLocaleString() }} </b-th>
<!--            <b-th v-if="selectAttendance !== '入座率資料(By film)'"> TOTAL FILM :{{ parseFloat(totalData.num_of_film).toLocaleString() }}</b-th>-->
            <b-th v-if="selectAttendance !== '入座率資料(By film)'"> TOTAL SHOW :{{ parseFloat(totalData.num_of_show).toLocaleString() }} </b-th>
            <b-th> TOTAL SEATS :{{ parseFloat(totalData.seats).toLocaleString() }}</b-th>
            <b-th> TOTAL ADM :{{ parseFloat(totalData.ta).toLocaleString() }}</b-th>
            <b-th> TOTAL B.O. :{{ parseFloat(totalData.tg).toLocaleString() }} </b-th>
            <b-th colspan="1"></b-th>
          </b-tr>
        </template>
        <template #cell()="data">
          <div v-if="data.field.numType" class="text-nowrap">
            {{ parseFloat(Number(data.value)).toLocaleString() }}
          </div>
          <div v-else>{{ data.value }}</div>
        </template>
        <template #cell(film_name_cn)="data">
          <div style="width: 130px">
            {{ data.item.film_name_cn }}
          </div>
        </template>
        <template #cell(occupancy)="data">
          <div>
            {{ data.item.occupancy }}
          </div>
        </template>
        <template #cell(film_name_en)="data">
          <div style="width: 150px">
            {{ data.item.film_name_en }}
          </div>
        </template>
        <template #cell(up_date)="data">
          <div
            class="text-nowrap"
            :style="
              data.item.up_date === '0001-01-01' ||
              data.item.up_date === '0000-00-00'
                ? 'color:red'
                : ''
            "
          >
            {{ isValidDate(data.item.up_date) }}
          </div>
        </template>
        <template #cell(down_date)="data">
          <div class="text-nowrap">
            {{
              isValidDate(dateOffFormat(data.item.down_date, data.item.up_date))
            }}
          </div>
        </template>
        <template #cell(num_of_theatre)="data">
          <div
              class="text-nowrap link-color"
              @click="goDetails(data.item, 'theatre')"
          >
            {{ parseFloat(Number(data.value)).toLocaleString() }}
          </div>
        </template>
        <template #cell(theatre_highest)="data">
          <div
            class="text-nowrap link-color"
            @click="goDetails(data.item, 'theatre')"
          >
            {{ parseFloat(Number(data.value)).toLocaleString() }}
          </div>
        </template>
        <template #cell(num_of_film)="data">
          <div
            class="text-nowrap link-color"
            @click="goDetails(data.item, 'film')"
          >
            {{ parseFloat(Number(data.value)).toLocaleString() }}
          </div>
        </template>
      </b-table>
      <p>紅色highlight代表有優先場</p>
    </b-card>
  </div>
</template>

<script>
import {
  getOccupancyByFilm,
  getOccupancyByHouse,
  getOccupancyByTheatre,
  selectShowFilms,
  getAreas,
  getCircuitTheatres,
  getFilmPengding,
} from '@/api/occupancy.js'
import datePickerCom from '@/views/components/datePicker.vue'
import store from '@/store'
import {getFilmRunListOfFilm} from '@/api/film-material-management/film'
import {getCircuitTheatreList} from '@/api/theatre'
export default {
  components: { datePickerCom },
  data() {
    return {
      displayText: '',
      inputSelectKey: 1,
      inputForFilm: '',
      selectPengdingFilm: '',
      searchForFilm: '',
      showTabel: false,
      areaSelect: '',
      timeNow: '',
      areaLoading: false,
      searchFilmLoading: false,
      theatreLoading: false,
      searchSelectVal: '',
      hideBox: false,
      searchData: '',
      tableLoading: false,
      min: '',
      max: '',
      toDate: '',
      fromDate: '',
      pageTotal: 10,
      perPage: 5,
      rows: 10000,
      currentPage: 1,
      selectAttendance: '入座率資料(By film)',
      optionAttendance: [
        '入座率資料(By film)',
        '入座率資料(By theatre)',
        '入座率資料(By house)',
        '入座率資料(By circuit)'
      ],
      selectCircuit: '',
      attendanceData: [],
      totalData: [],
      listParams: {
        page: 1,
        count: 10,
      },
      searchFilmList: [],
      newSearchFilmList: [],
      areaList: [],
      newFilmList: [],
      film_id: '',
      master_id: '',
      run_ver: '',
      // P3：輪次篩選改用「輪次字典 id」（run_ver_property_id）。
      // run_ver 仍保留 —— 只作為畫面顯示（下拉標籤／明細頁標題）。
      runVerPropertyId: '',
      circuit_id: '',
      theatre_id: '',
      pengdingFilmList: [],
      filmListData: [],
      filmList: [],
      timer: null,
    }
  },
  computed: {
    tableFields() {
      if (this.selectAttendance === '入座率資料(By film)') {
        return [
          { key: 'film_name_cn', label: '電影名稱', sortable: true },
          { key: 'film_name_en', label: 'Film name', sortable: true },
          { key: 'up_date', label: '上映日期', sortable: true },
          { key: 'down_date', label: '落畫日期', sortable: true },
          { key: 'country', label: 'Country', sortable: true },
          {
            key: 'theatre_highest',
            label: '最高戲院數目',
            sortable: true,
            numType: true,
          },
          {
            key: 'screen_highest',
            label: '最高銀幕數目',
            sortable: true,
            numType: true,
          },
          {
            key: 'num_shows',
            label: '總場次',
            sortable: true,
            numType: true,
          },
          { key: 'seats', label: '期間座位', sortable: true, numType: true },
          { key: 'ta', label: '期間人次', sortable: true, numType: true },
          { key: 'tg', label: '期間票房', sortable: true, numType: true },
          { key: 'occupancy', label: '入座率', sortable: true },
        ]
      } else if (this.selectAttendance === '入座率資料(By theatre)') {
        return [
          { key: 'circuit_name', label: 'Circuit Name', sortable: true },
          { key: 'theatre_name', label: 'Theatre Name', sortable: true },
          {
            key: 'num_of_film',
            label: 'No. of film',
            sortable: true,
            numType: true,
          },
          {
            key: 'num_of_show',
            label: 'No. of show',
            sortable: true,
            numType: true,
          },
          { key: 'seats', label: '期間座位', sortable: true, numType: true  },
          { key: 'ta', label: '期間人次', sortable: true, numType: true },
          { key: 'tg', label: '期間票房', sortable: true, numType: true },
          { key: 'occupancy', label: '入座率', sortable: true },
        ]
      } else if (this.selectAttendance === '入座率資料(By circuit)') {
        return [
          { key: 'circuit_name', label: 'Circuit Name', sortable: true },
          { key: 'num_of_theatre', label: 'No. of theatre', sortable: true, numType: true },
          {
            key: 'num_of_film',
            label: 'No. of film',
            sortable: true,
            numType: true,
          },
          {
            key: 'num_of_show',
            label: 'No. of show',
            sortable: true,
            numType: true,
          },
          { key: 'seats', label: '期間座位', sortable: true, numType: true  },
          { key: 'ta', label: '期間人次', sortable: true, numType: true },
          { key: 'tg', label: '期間票房', sortable: true, numType: true },
          { key: 'occupancy', label: '入座率', sortable: true },
        ]
      } else {
        return [
          { key: 'circuit_name', label: 'Circuit Name', sortable: true },
          { key: 'theatre_name', label: 'Theatre Name', sortable: true },
          { key: 'house_id', label: 'House No.', sortable: true },
          {
            key: 'num_of_film',
            label: 'No. of film',
            sortable: true,
            numType: true,
          },
          {
            key: 'num_of_show',
            label: 'No. of show',
            sortable: true,
            numType: true,
          },
          { key: 'seats', label: '期間座位', sortable: true, numType: true  },
          { key: 'ta', label: '期間人次', sortable: true, numType: true },
          { key: 'tg', label: '期間票房', sortable: true, numType: true },
          { key: 'occupancy', label: '入座率', sortable: true },
        ]
      }
    },
    canSearch() {
      if (this.selectAttendance === '入座率資料(By film)') {
        if (
          this.selectCircuit ||
          this.selectPengdingFilm ||
          this.searchForFilm ||
          this.inputForFilm
        ) {
          return false
        } else {
          return true
        }
      } else {
        return false
      }
    },
    searchFilmOption() {
      return function (key, item) {
        const newlist = []
        key.map((el) => {
          newlist.push({
            label: `[${el}]`,
            id: item.films[el][0].master_id,
            type: 'master',
          })
          item.films[el].map((child) => {
            newlist.push({
              label: ` -- (${child.remark_1}版${
                child.remark_2 ? `, ${child.remark_2}版` : ''
              }) ${child.date_release}`,
              id: child.id,
              type: 'film',
            })
          })
        })
        return newlist
      }
    },
    searchName() {
      if (this.selectAttendance === '入座率資料(By film)') {
        return 'Search for film'
      } else if (this.selectAttendance === '入座率資料(By theatre)') {
        return 'Search for theatre'
      } else {
        return false
      }
    },
    selectForFilm() {
      if (this.selectAttendance === '入座率資料(By film)') {
        return '選擇戲院/院線'
      } else if (this.selectAttendance === '入座率資料(By theatre)' || this.selectAttendance === '入座率資料(By circuit)') {
        return '上映或者即將上映的電影'
      } else {
        return '選擇戲院'
      }
    },
  },
  watch: {
    selectAttendance(val) {
      this.searchData = ''
      this.selectCircuit = ''
      this.film_id = ''
      this.master_id = ''
      this.run_ver = ''
      this.runVerPropertyId = ''
      this.circuit_id = ''
      this.theatre_id = ''
      this.areaSelect = ''
      this.selectPengdingFilm = ''
      this.searchForFilm = ''
      this.showTabel = false
      this.hideBox = false
      this.inputForFilm = ''
      this.setDate()
      if (val) {
        store.commit('updateStateData')
      }
    },
    hideBox() {
      this.getCircuitTheatres()
    },
    fromDate() {
      this.getCircuitTheatres()
    },
    toDate() {
      this.getCircuitTheatres()
    }
  },
  methods: {
    updateDisplayText() {
      // 构建区域名称
      const area = this.areaList.find(item => item.id === this.areaSelect)
      const areaName = area ? area?.name_en || '' : ''

      // 查找选中的 pending film
      const pendingFilm = this.pengdingFilmList.find(item => item.id === this.selectPengdingFilm)
      const pendingFilmName = pendingFilm ? pendingFilm.name : ''

      // 查找选中的 film
      const film = this.filmList.find(item => item.id === this.inputForFilm)
      const filmName = film ? film.value : ''

      const cleanCircuit = (this.selectCircuit || '').replace(/\s*:undefined\s*/g, ' ').trim()

      const region = sessionStorage.getItem('area') || ''

      // 拼接最终文本
      this.displayText = `${this.fromDate} ~ ${this.toDate} ${region} ${areaName} ${cleanCircuit} ${pendingFilmName} ${filmName}`.trim()
    },
    clearSearchFilm() {
      this.master_id = ''
      this.film_id = ''
      this.run_ver = ''
      this.runVerPropertyId = ''
    },
    changeAttendance(val) {
      if (val === '入座率資料(By film)') {
        this.getCircuitTheatres()
        this.getAreas()
      } else if (val === '入座率資料(By house)') {
        this.getCircuitTheatres()
      } else {
        this.getFilmPengding()
        this.getAreas()
      }
      this.$router.push({
        name: 'attendance-data',
        query: { page: val },
      })
    },
    goDetails(value, type) {
      // P3：輪次字典 id 以「被點的那一列」為優先 —— occupancy 的每一列本來就是
      // （影片 + 輪次）或（戲院 + 該輪），列上就有後端回傳的 run_ver_property_id；
      // 只有列上沒有時（By theatre／By circuit 的戲院列）才退回頁面挑選的輪次。
      // 之前一律用頁面狀態，只按日期查詢時它是空的 → 明細頁沒帶輪次，
      // 後端單收 film_master_id 又不篩選，會把整個區間的片都查出來。
      const runVerPropertyId = value.run_ver_property_id || this.runVerPropertyId || ''
      const runVerName = value.run_ver || this.run_ver || ''
      let titleName = type === 'theatre'
        ? `${this.displayText} ${value.film_name_cn} * ${value.film_name_en} - ${runVerName}`
        : `${this.displayText} ${value.theatre_name}`
      if (this.selectAttendance === '入座率資料(By circuit)') {
        titleName = `${this.displayText} ${value.circuit_name}`
      }
      this.$router.push({
        name: 'attendance-data-details',
        query: {
          id: value.id, // master_id or theatre_id
          // run_ver 只給畫面顯示（標題的輪次名）；傳給 API 的是字典 id
          run_ver: runVerName,
          run_ver_property_id: runVerPropertyId,
          film_master_id: value.master_id,
          film_id: this.film_id, // film_id
          houseId: value.screen_id || '',
          area: this.areaSelect,
          region: sessionStorage.getItem('area') || '',
          type,
          from_circuit: this.selectAttendance === '入座率資料(By circuit)',
          dateStart: this.fromDate,
          dateEnd: this.toDate,
          titleName
        },
      })
    },
    querySearch(queryString, cb) {
      const restaurants = this.filmListData
      const results = queryString
        ? this.createFilter(queryString, restaurants)
        : restaurants
      cb(results)
    },
    createFilter(queryString, restaurants) {
      return restaurants.filter((item) => item.value.toLowerCase().includes(queryString.toLowerCase())
      )
    },
    disabledDate(time) {
      // time.getTime() < Date.now() - 8.64e7 禁用不包含當前日期
      // time.getTime() > Date.now() - 8.64e7 禁用包含當前日期
      const nextYearDate = this.$moment(this.fromDate)
        .add(1, 'years')
        .add(1, 'days')
        .format('YYYY-MM-DD')
      return (
        time.getTime() < new Date(this.fromDate).getTime() - 8.64e7 ||
        time.getTime() > new Date(nextYearDate).getTime()
      )
    },
    selectAreaChange(val) {
      // if (val === '入座率資料(By film)') {
      //   // this.selectCircuit = ''
      //   // this.getCircuitTheatres()
      //   // this.inputForFilm = ''
      // } else {
      //   // this.selectPengdingFilm = ''
      //   // this.inputForFilm = ''
      // }
    },
    inputSearchFilm() {
      //輸入下拉 input事件
      //篩選后清空其他搜索框内容
      this.selectPengdingFilm = ''
      // this.getFilmListOfFilm(this.inputForFilm)
    },
    inputSearchFilmChange(val) {
      //輸入下拉 change事件
      // this.inputSelectKey++;
      if (!val) {
        this.film_id = ''
        this.master_id = ''
        this.run_ver = ''
        this.runVerPropertyId = ''
      }
      this.selectPengdingFilm = ''
      this.setDate()
    },
    selectPengdingChange(val) {
      if (!val) {
        this.film_id = ''
      }
    },
    selectPengdingOption(val) {
      //上映中電影 select事件
      if (val) {
        this.film_id = val.id
        // P3：上映中電影清單已帶輪次字典 id，選片時一併記下，
        // 明細頁才帶得到輪次（這也是 By theatre／By circuit 唯一的輪次來源）
        this.runVerPropertyId = val.run_ver_property_id || ''
        //篩選后清空其他搜索框内容
        this.searchForFilm = ''
        this.inputForFilm = ''
        this.setDate()
      }
      // this.areaSelect = ''
    },
    getFilmPengding() {
      //獲取上映中電影數據
      getFilmPengding()
        .then((res) => {
          this.pengdingFilmList = res.data
        })
        .catch(() => {
        })
    },
    selectCircuitOption(value) {
      if (value.children) {
        this.circuit_id = value.id
        this.theatre_id = ''
      } else {
        this.circuit_id = ''
        this.theatre_id = value.id
      }
    },
    searchFilmInput(value) {
      const todate = this.$moment().subtract(1, 'days').format('YYYY-MM-DD')
      const defaultDate = this.$moment()
        .subtract(7, 'days')
        .format('YYYY-MM-DD')
      let startDate = ''
      let endDate = ''
      if (value.type === 'film' || value.type === 'master') {
        startDate =
          value.date_release !== '0001-01-01' ? value.date_release : defaultDate
        endDate =
          value.date_release >= todate
            ? this.$moment(value.date_release)
              .add(6, 'days')
              .format('YYYY-MM-DD')
            : value.date_off !== '0000-00-00'
              ? value.date_off
              : todate
      } else {
        startDate = defaultDate
        endDate = todate
      }
      this.fromDate = startDate
      this.toDate = endDate
      this.min = this.fromDate
      this.max = this.toDate
      // this.inputForFilm = value.value
      this.selectPengdingFilm = ''
      // this.areaSelect = ''
      if (value.type === 'master') {
        this.master_id = value.id
        this.film_id = ''
        this.run_ver = value.run_ver
        this.runVerPropertyId = value.run_ver_property_id || ''
      } else {
        this.master_id = ''
        this.film_id = value.id
        // 子版本（type=film）本身屬於母片的輪次，輪次資訊由清單帶下來
        this.run_ver = value.run_ver || ''
        this.runVerPropertyId = value.run_ver_property_id || ''
      }
      // this.master_id = value.id
    },
    remoteMethod(query) {
      this.filmList = []
      if (query !== '') {
        clearTimeout(this.timer)
        this.timer = setTimeout(async () => {
          this.filmList = await this.getFilmListOfFilm(query)
        }, 1000)
        return query
      }
      this.filmList = []
      return query
    },
    setDate() {
      //set date
      const todate = this.$moment().subtract(1, 'days').format('YYYY-MM-DD')
      const defaultDate = this.$moment()
        .subtract(7, 'days')
        .format('YYYY-MM-DD')
      const minDate = this.$moment().subtract(1, 'years').format('YYYY-MM-DD')
      this.toDate = todate
      this.fromDate = defaultDate
      this.min = minDate
      this.max = todate
    },
    getCircuitTheatres() {
      this.theatreLoading = true
      const data = {
        // area: this.areaSelect, 不支持的参数
        from_date: this.fromDate,
        to_date: this.toDate,
        area: sessionStorage.getItem('area') || ''
      }
      getCircuitTheatreList(data)
        .then((res) => {
          const newFilmList = []
          res.data.map((el) => {
            if (this.selectAttendance === '入座率資料(By film)') {
              newFilmList.push(el)
            }
            if (el.children.length > 0) {
              el.children.map((child) => {
                child.full_name = `- 戲院： ${child.full_name}`
                newFilmList.push(child)
              })
            }
          })
          const all = {
            full_name:
              this.selectAttendance === '入座率資料(By film)'
                ? '所有院線和戲院'
                : '所有戲院',
            circuit_key: '',
            id: '',
          }
          newFilmList.unshift(all)
          this.newFilmList = newFilmList
          this.theatreLoading = false
        })
        .catch(() => {
          this.theatreLoading = false
        })
    },
    getAreas() {
      this.areaLoading = true
      getAreas({ region: sessionStorage.getItem('area') || '' })
        .then((res) => {
          const newList = []
          res.data.map((el) => {
            el.states.map((child) => {
              newList.push(child)
              child.districts.map((kid) => {
                kid.name = `- ${kid.name}`
                newList.push(kid)
              })
            })
          })
          const all = {
            name: 'All districts',
            id: '',
          }
          newList.unshift(all)
          this.areaList = newList
          this.areaLoading = false
        })
        .catch(() => {
          this.areaLoading = false
        })
    },
    selectShowFilms(val) {
      this.searchSelectVal = val ? val : ''
      const data = {
        search: this.searchSelectVal,
      }
      selectShowFilms(data)
        .then((res) => {
          this.searchFilmList = res.data
          const newList = []
          this.searchFilmList.map((el) => {
            el.film_name = `${el.name_chinese} * ${el.name_english}`
          })
          // this.newSearchFilmList = newList
        })
        .catch(() => {
        })
    },
    searchInfo(type) {
      this.showTabel = true
      if (!this.searchForFilm && type === '入座率資料(By film)') {
        // this.hideBox = true
      }

      if (type === '入座率資料(By film)') {
        this.searchSelectVal = ''
        // this.getFilmMasterApi()
        this.getOccupancyByFilm()
      } else if (type === '入座率資料(By house)') {
        this.getOccupancyByHouse()
      } else if (type === '入座率資料(By circuit)') {
        this.getOccupancyByCircuit()
      } else {
        this.getOccupancyByTheatre()
      }
      store.commit('updateStateData')
      this.updateDisplayText()
    },
    getOccupancyByFilm() {
      this.tableLoading = true
      const data = {
        date_start: this.fromDate,
        date_end: this.toDate,
        search: this.film_id || this.master_id ? '' : this.inputForFilm,
        hide: this.hideBox,
        area: this.areaSelect,
        region: sessionStorage.getItem('area'),
        film_master_id: this.master_id,
        film_id: this.film_id,
        run_ver_property_id: this.runVerPropertyId,
        circuit: this.circuit_id,
        theatre: this.theatre_id,
        page: this.currentPage,
        count: this.rows,
      }
      if (this.circuit_id) {
        data.theatre = ''
      } else {
        data.circuit = ''
      }
      getOccupancyByFilm(data)
        .then((res) => {
          this.attendanceData = res.data

          const dataList = []

          res.data.forEach((el) => {
            el.date_release = el.run_ver_info.date_release
            el.date_on = el.run_ver_info.date_on
            el.date_off = el.run_ver_info.date_off
            el.date_to_report = el.run_ver_info.date_to_report
            dataList.push({
              id: el.film_master.id,
              // 明細頁（film 型）用 film_master_id 當影片錨點，缺了它只帶輪次也篩不動
              master_id: el.film_master.id,
              run_ver: el.run_ver_info.run_ver,
              // P3：這一列的輪次字典 id，明細頁就是靠它篩輪次
              run_ver_property_id: el.run_ver_info.run_ver_property_id,
              film_name_cn: el.film_master.name_chinese,
              film_name_en: el.film_master.name_english,
              country: el.film_master.country,
              _rowVariant:
                  (new Date(el.date_on) < new Date(el.date_release) && new Date(el.date_on) <= new Date(this.toDate) && new Date(el.date_release) >= new Date(this.fromDate))
                    ? 'danger'
                    : '',
              theatre_highest: el.num_theatre,
              tg: el.gross,
              occupancy: el.occupancy,
              ta: el.admissions_total,
              seats: el.adm_per_seats,
              screen_highest: el.num_screen,
              num_shows: el.num_shows,
              up_date: el.run_ver_info.date_release,
              down_date: el.date_off,
            })
          })
          
          // 计算汇总数据
          const totalData = {
            film_name_cn: 'Total',
            film_name_en: '',
            country: '',
            up_date: '',
            down_date: '',
            theatre_highest: '',
            screen_highest: '',
            num_shows: '',
            occupancy: '',
            ta: dataList.reduce((sum, item) => sum + (parseFloat(item.ta) || 0), 0),
            tg: dataList.reduce((sum, item) => sum + (parseFloat(item.tg) || 0), 0),
            seats: dataList.reduce((sum, item) => sum + (parseFloat(item.seats) || 0), 0),
            _rowVariant: 'primary',
          }
          
          // 将汇总行追加到数据末尾
          this.attendanceData = [...dataList]
          this.totalData = totalData
          this.pageTotal = this.attendanceData.length
          this.tableLoading = false
        })
        .catch(() => {
          this.tableLoading = false
        })
    },
    getOccupancyByHouse() {
      this.tableLoading = true
      const data = {
        date_start: this.fromDate,
        date_end: this.toDate,
        theatre: this.theatre_id,
        region: sessionStorage.getItem('area'),
        page: 1,
        count: 1000,
      }
      getOccupancyByHouse(data)
        .then((res) => {
          const list = []
          res.data.map((el) => {
            list.push({
              id: el.theatre ? el.theatre.id : '',
              screen_id:
                el.house && el.house.house_name ? el.house.screen_id : '',
              circuit_name:
                el.theatre && el.theatre.circuit ? el.theatre.circuit : '-',
              theatre_name:
                el.theatre && el.theatre.full_name ? el.theatre.full_name : '-',
              house_id:
                el.house && el.house.house_name ? el.house.house_name : '-',
              num_of_film: el.num_film,
              num_of_show: el.num_show,
              ta: el.admissions_total,
              tg: el.gross,
              seats: el.adm_per_seats,
              occupancy: el.occupancy,
            })
          })
          
          // 计算汇总数据
          const totalData = {
            circuit_name: 'Total',
            theatre_name: '',
            house_id: '',
            num_of_film: list.reduce((sum, item) => sum + (parseInt(item.num_of_film) || 0), 0),
            num_of_show: list.reduce((sum, item) => sum + (parseInt(item.num_of_show) || 0), 0),
            ta: list.reduce((sum, item) => sum + (parseFloat(item.ta) || 0), 0),
            tg: list.reduce((sum, item) => sum + (parseFloat(item.tg) || 0), 0),
            seats: list.reduce((sum, item) => sum + (parseFloat(item.seats) || 0), 0),
            occupancy: '',
            _rowVariant: 'primary',
          }
          
          // 将汇总行追加到数据末尾
          this.attendanceData = [...list]
          this.totalData = totalData
          this.pageTotal = this.attendanceData.length
          this.tableLoading = false
        })
        .catch(() => {
          this.tableLoading = false
        })
    },
    getOccupancyByTheatre() {
      this.tableLoading = true
      const data = {
        date_start: this.fromDate,
        date_end: this.toDate,
        search: this.film_id || this.master_id ? '' : this.inputForFilm,
        area: this.areaSelect,
        film_id: this.film_id,
        film_master_id: this.master_id,
        run_ver_property_id: this.runVerPropertyId,
        region: sessionStorage.getItem('area'),
        page: 1,
        count: 10000,
      }
      getOccupancyByTheatre(data)
        .then((res) => {
          const list = []
          res.data.map((el) => {
            list.push({
              id: el.theatre.id,
              circuit_name: el.theatre.circuit,
              theatre_name: el.theatre.full_name,
              num_of_film: el.num_film,
              num_of_show: el.num_show,
              ta: el.admissions_total,
              tg: el.gross,
              seats: el.adm_per_seats,
              occupancy: el.occupancy,
            })
          })
          
          // 计算汇总数据
          const totalData = {
            circuit_name: 'Total',
            theatre_name: '',
            num_of_film: list.reduce((sum, item) => sum + (parseInt(item.num_of_film) || 0), 0),
            num_of_show: list.reduce((sum, item) => sum + (parseInt(item.num_of_show) || 0), 0),
            ta: list.reduce((sum, item) => sum + (parseFloat(item.ta) || 0), 0),
            tg: list.reduce((sum, item) => sum + (parseFloat(item.tg) || 0), 0),
            seats: list.reduce((sum, item) => sum + (parseFloat(item.seats) || 0), 0),
            occupancy: '',
            _rowVariant: 'primary',
          }
          
          // 将汇总行追加到数据末尾
          this.attendanceData = [...list]
          this.totalData = totalData
          this.pageTotal = this.attendanceData.length
          this.tableLoading = false
        })
        .catch(() => {
          this.tableLoading = false
        })
    },
    getOccupancyByCircuit() {
      this.tableLoading = true
      const data = {
        date_start: this.fromDate,
        date_end: this.toDate,
        search: this.film_id || this.master_id ? '' : this.inputForFilm,
        area: this.areaSelect,
        film_id: this.film_id,
        film_master_id: this.master_id,
        run_ver_property_id: this.runVerPropertyId,
        region: sessionStorage.getItem('area'),
        group_by_circuit: false,
      }
      getOccupancyByTheatre(data).then((res) => {
        const list = []
        res.data.map((el) => {
          list.push({
            id: el.circuit_id,
            circuit_name: el.circuit,
            num_of_theatre: el.num_theatre,
            num_of_film: el.num_film,
            num_of_show: el.num_show,
            ta: el.admissions_total,
            tg: el.gross,
            seats: el.adm_per_seats,
            occupancy: el.occupancy,
          })
        })
        
        // 计算汇总数据
        const totalData = {
          circuit_name: 'Total',
          num_of_theatre: list.reduce((sum, item) => sum + (parseInt(item.num_of_theatre) || 0), 0),
          num_of_film: list.reduce((sum, item) => sum + (parseInt(item.num_of_film) || 0), 0),
          num_of_show: list.reduce((sum, item) => sum + (parseInt(item.num_of_show) || 0), 0),
          ta: list.reduce((sum, item) => sum + (parseFloat(item.ta) || 0), 0),
          tg: list.reduce((sum, item) => sum + (parseFloat(item.tg) || 0), 0),
          seats: list.reduce((sum, item) => sum + (parseFloat(item.seats) || 0), 0),
          occupancy: '',
          _rowVariant: 'primary',
        }
        
        // 将汇总行追加到数据末尾
        this.attendanceData = [...list]
        this.totalData = totalData
        this.tableLoading = false
      }).catch(() => {
        this.tableLoading = false
      })
    },
    getFilmListOfFilm(val) {
      this.searchFilmLoading = true
      let searchVal = val
      if (typeof val === 'string') {
        searchVal = val
      } else {
        searchVal = ''
        this.searchForFilm = ''
      }
      const data = {
        search: searchVal,
      }
      const list = []
      this.filmList = []
      getFilmRunListOfFilm(data).then((res) => {
        res.data.map((item) => {
          const date_release = this.isValidDate(item.date_release) === '0000-00-00'
            ? '00-00-0000'
            : this.isValidDate(item.date_release)
          const date_off = this.isValidDate(
            this.dateOffFormat(item.date_off, item.date_release)
          )
          list.push({
            id: item.id,
            value: `${item.name_zh}*${item.name_en}-輪次: ${item.run_ver} - (${date_release} to ${date_off})`,
            type: 'master',
            date_release: item.date_release,
            date_off: item.date_off,
            run_ver: item.run_ver,
            // P3：/api/film-select 已回傳字典 id，往下帶給 occupancy 查詢用
            run_ver_property_id: item.run_ver_property_id
          })
          if (item.children && item.children.length > 0) {
            item.children.map((el) => {
              const remark = el.remark_2
                ? `${el.remark_1}[${el.remark_2}]`
                : el.remark_1
              list.push({
                id: el.id,
                master_id: el.master_id,
                type: 'film',
                // 子版本沿用母片（輪次行）的輪次，選子版本時才不會把輪次弄丟
                run_ver: item.run_ver,
                run_ver_property_id: item.run_ver_property_id,
                value: `- ${el.title_name} 輪次: ${item.run_ver}${el.language ? ` (${el.language}, ${remark})` : ` (${remark})`}`,
                date_release: el.date_release,
                date_off: el.date_off,
              })
            })
          }
        })
        this.searchFilmLoading = false
      })
      return list
    },
  },
  created() {
    if (!this.hideBox) {
      this.fromDate = ''
      this.toDate = ''
    }
    this.selectAttendance = this.$route.query.page || '入座率資料(By film)'
    this.setDate()
    this.getAreas()
    this.getCircuitTheatres()
    this.changeAttendance(this.selectAttendance)
  },
}
</script>

<style lang="scss">
.el-autocomplete-suggestion {
  li {
    white-space: normal;
  }
}
</style>
<style lang="scss" scoped>
.date-pick {
  display: flex;
  .from-date,
  .to-date {
    margin-right: 20px;
  }
  .hide-checkbox {
    position: relative;
    top: 35px;
  }
  .select-film-name {
    position: relative;
    top: 25px;
  }
}
.search {
  display: flex;
  margin-bottom: 20px;
}
.link-color {
  color: #0e72bc;
}
.all-film-list {
}

tr.foot-row {
  font-weight: bold;
  background-color: #f8f9fa;
}
</style>
